import { createContext } from 'react';

/**
 * Type of entity that can be displayed in a drawer
 */
export type EntityType = 'customer' | 'seller' | 'vehicle' | 'business';

/**
 * Represents a single drawer in the EntityExplorer system
 */
export interface EntityDrawer {
  /** Unique identifier for this drawer instance */
  id: string;
  /** Type of entity being displayed */
  type: EntityType;
  /** ID of the entity to display */
  entityId: string;
  /** Title to show in the drawer header */
  title: string;
  /** Z-index for stacking (85-88) */
  zIndex: number;
}

/**
 * Context value for EntityExplorer
 * Provides access to drawer state and manipulation functions
 */
export interface EntityExplorerContextValue {
  /** Array of currently open drawers */
  drawers: EntityDrawer[];
  /** Open a new drawer */
  openDrawer: (type: EntityType, entityId: string, title: string) => void;
  /** Close a specific drawer by ID */
  closeDrawer: (id: string) => void;
  /** Close the topmost (most recently opened) drawer */
  closeTopDrawer: () => void;
  /** Close all open drawers */
  closeAll: () => void;
}

/**
 * React Context for EntityExplorer
 * Must be used within EntityExplorerProvider
 */
export const EntityExplorerContext = createContext<EntityExplorerContextValue | undefined>(
  undefined,
);
